import { boot } from 'quasar/wrappers';
import { init } from 'composables/bugsnag';

/**
 * Initializes Bugsnag.
 */
export default boot(({ app }) => {
  init({ app, executionContext: 'ui' });
});
